"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTask = exports.TaskStruct = void 0;
var superstruct_1 = require("superstruct");
var isStruct_1 = require("../utils/isStruct");
var Address_1 = require("./Address");
var Customer_1 = require("./Customer");
var Timestamp_1 = require("./Timestamp");
exports.TaskStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    externalOrderId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    externalOrderNumber: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    externalOrderCreatedAt: (0, superstruct_1.optional)(Timestamp_1.TimestampStruct),
    riderId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    createdAt: Timestamp_1.TimestampStruct,
    updatedAt: Timestamp_1.TimestampStruct,
    assignedAt: (0, superstruct_1.optional)(Timestamp_1.TimestampStruct),
    startedAt: (0, superstruct_1.optional)(Timestamp_1.TimestampStruct),
    completedAt: (0, superstruct_1.optional)(Timestamp_1.TimestampStruct),
    /**
     * @deprecated use `promisedDeliveryTimeInMinutes` instead.
     */
    deliveryTimeInMinutes: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    promisedDeliveryTimeInMinutes: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    polygonDeliveryTimeInMinutes: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    throttledDeliveryTimeInMinutes: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    estimatedDeliveryAt: (0, superstruct_1.optional)(Timestamp_1.TimestampStruct),
    estimatedArrivalAtStoreAt: (0, superstruct_1.optional)(Timestamp_1.TimestampStruct),
    estimatedPickUpDurationInSeconds: (0, superstruct_1.optional)((0, superstruct_1.record)((0, superstruct_1.string)(), (0, superstruct_1.number)())),
    failureReason: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    failureNotes: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    warehouseId: (0, superstruct_1.string)(),
    hasArrivedAtCustomer: (0, superstruct_1.boolean)(),
    arrivedAtCustomerAt: (0, superstruct_1.optional)(Timestamp_1.TimestampStruct),
    hasArrivedAtStore: (0, superstruct_1.boolean)(),
    arrivedAtStoreAt: (0, superstruct_1.optional)(Timestamp_1.TimestampStruct),
    clonedFromTaskId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    cloneReason: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    address: Address_1.AddressStruct,
    customer: Customer_1.CustomerStruct,
    noteFromCustomer: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    isIdCheckRequired: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
    thirdPartyProvider: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    thirdPartyProviderTaskId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    requestedThirdPartyProviderAt: (0, superstruct_1.optional)(Timestamp_1.TimestampStruct),
    isRunningThirdPartyProviderAction: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
    isAutoAssigned: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
    isDeleted: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
    isAnonymized: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
    hasPriority: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
    status: (0, superstruct_1.string)(),
    isAutoAssignmentDisabled: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
    pickingStatus: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    pickingStartedAt: (0, superstruct_1.optional)(Timestamp_1.TimestampStruct),
    pickingEndedAt: (0, superstruct_1.optional)(Timestamp_1.TimestampStruct),
});
function isTask(obj) {
    return (0, isStruct_1.isStruct)(obj, exports.TaskStruct, "Task");
}
exports.isTask = isTask;
